
import Previewer from 'vux/src/components/previewer/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

import { getImgUrl, makeImgFileName, randomn, getImgFileReallyName } from '@/lib/utils'

const setHeader = {
'kp-token': sessionStorage.token || '',
'kp-request-id': '5' + new Date().getTime().toString() + randomn(4),
'kp-source': 5,
'kp-version': '',
'kp-language': 'zh_CN'
}
export default {
data() {
return {
setHeader,
uploadUrl: '',
files: [],
options: {
getThumbBoundsFn (index) {

let thumbnail = document.querySelectorAll('.previewer-demo-img')[index]

let pageYScroll = window.pageYOffset || document.documentElement.scrollTop


let rect = thumbnail.getBoundingClientRect()

return {x: rect.left, y: rect.top + pageYScroll, w: rect.width}


}
}
}
},
directives: {
TransferDom
},
computed: {
getClassType () {
if (this.type == 1) {
return {
li: 'img-item',
delIcon: 'del-icon'
}
} else if (this.type == 2) {
return {
li: 'img-line-item',
delIcon: 'del-icon-small'
}
} else {
return {
li: 'img-item',
delIcon: 'del-icon'
}
}
}
},
props: {
name: {
type: String,
default: 'files'
},
type: {
type: Number,
default: 1 // 1 多选铺开大图显示模式 2 单个行内显示
},
multiple: {
type: Boolean,
default: false
},
maxLength: {
type: Number,
default: 1
},
isEdit: {
type: Boolean,
default: true
},
/**
* value => [{
blob: String, // 图片路径
name: String, // 图片名称
src: String, // 大图路径
response: {
code: 0,  // 服务端响应码
data: [{
name: String, // 图片名称
relativePath: String 
}]
}
}]
*/
value: {
type: Array,
default: () => []
}
},
components: {
Previewer
},
watch: {
value: {
handler (newValue) {
this.files = newValue
}
}
},
mounted () {
const uploadUrl1 = 'https://api.kuaipiyun.com/file/oss/corp/upload'
const uploadUrl2 = 'https://api.kuaipiyun.com/file/oss/upload/back/single'

if (this.name == 'files') {
this.uploadUrl = uploadUrl1
} else if (this.name == 'file') {
this.uploadUrl = uploadUrl2
} else {
this.uploadUrl = uploadUrl1
}
},
methods: {
getImgUrl,
getImgFileReallyName,
inputFile (newFile, oldFile) {
if (newFile && newFile.active && newFile.response && newFile.response.code >= 0) {
this.$vux.loading.hide()
if (newFile.response.code != 0) {
this.$emit('update-error')
this.$vux.toast.text(newFile.response.msg, 'top')
return
} else {

newFile.src = getImgUrl(newFile.response.data[0].relativePath)
this.$emit('update-success', this.files.concat([]), {
type: 'add',
file: newFile
})
}
}
},
inputFilter(newFile, oldFile, prevent) {
if (newFile && !oldFile) {

if (newFile.size > 20971520) {
this.$vux.toast.show({
text: '图片不能超过20M',
type: 'cancel',
width: '140px'
})
return prevent()
}




if (!/\.(jpeg|jpe|jpg|gif|png|webp)$/i.test(newFile.name)) {
return prevent()
}
this.$vux.loading.show({text: '上传中...'})

newFile.blob = ''
let URL = window.URL || window.webkitURL
if (URL && URL.createObjectURL) {
newFile.name = makeImgFileName(newFile.name)
newFile.blob = URL.createObjectURL(newFile.file)
newFile.active = true
}
}
if (!newFile && oldFile) {




}
},
preview (index) {
this.$refs.previewer.show(index)
},
del (file) {
this.$refs.upload.remove(file)
this.$emit('update-success', this.files.concat([]), {
type: 'delete',
file
})
}
}
};



// WEBPACK FOOTER //
// ./src/plugin/KpFileUpload.vue